import React from 'react'

import Grid from 'components/Grid'

import classes from './GridContainer.module.scss'

/** @type {import("./types").default} */
const GridContainer = React.forwardRef((props, ref) => {
  const { className, children } = props

  return (
    <Grid
      className="GridContainer"
      container
      ref={ref}
      classes={{ container: classes.gridContainer, root: className }}
      {...props}
    >
      {children}
    </Grid>
  )
})

export default GridContainer
